import {create} from 'zustand'
import {createJSONStorage, persist} from "zustand/middleware";

const useAuthStore = create(persist((set) => ({
    token: null,
    user: null,
    roles: null,
    permissions: null,
    merchant: null,
    merchants: [],
    testMode: null,
    authChecked: false,

    setAuthChecked: () => set({authChecked: true}),

    setImpersonateToken: (value) => set({
        token: value,
        user: null,
        roles: null,
        permissions: null,
        merchant: null,
        merchants: [],
        testMode: null,
    }),

    clearToken: () => set({
        token: null,
        user: null,
        roles: null,
        permissions: null,
        merchant: null,
        merchants: [],
        testMode: null,
    }),
    setToken: (value) => set({token: value}),
    setUserAuth: (value) => set({...value}),
    setUser: (value) => set({user: value}),
    setRoles: (value) => set({roles: value}),
    setPermissions: (value) => set({permissions: value}),
    setMerchant: (value) => set({merchant: value}),
    setMerchants: (value) => set({merchants: value}),
    setTestMode: (value) => set({testMode: value}),
}), {
    name: 'x-auth', // name of item in the storage (must be unique)
    // Use cookie storage with 30-day expiration for persistent auth across browser sessions
    // storage: createCookieStorage({ name: 'x-auth', days: 30 }),
    storage: createJSONStorage(() => localStorage), // (optional) by default, 'localStorage' is used, sessionStorage
    partialize: (state) => ({
        token: state.token,
    }),
}))

export default useAuthStore;
